import { api } from "@/api"
import { useQuery } from "@tanstack/vue-query"

type BusinessFundingConfig = {
  date: Date
  fundedAmount: number
  fundedNumber: number
  contactPhone: string
  contactEmail: string
  businessFundingUrl: string | null
}

export const retrieveBusinessFundingConfig = async () => {
  const { body } = await api.get<
    RecursivelyConvertDatesToStrings<BusinessFundingConfig>
  >("/business-funding-config/")
  return {
    ...body,
    date: DateFns.parseISO(body.date),
  }
}

export const useBusinessFundingConfig = () =>
  useQuery({
    queryKey: [
      BASE_BUSINESS_FUNDING_CONFIG_QUERY_KEY,
    ] as const,
    queryFn: retrieveBusinessFundingConfig,
    staleTime: Infinity,
  })
